import $http from '@vue-util/http';
import { getUserGuid } from '../utils/cookieUtils';
import isBcom from '../utils/isBcom';

export const productXapiFetchLarge = async (productId, urlParams = {}) => {
  const url = `/xapi/digital/v1/product/${productId}?${new URLSearchParams({
    size: 'large',
    clientId: 'PROS',
    currencyCode: 'USD',
    _regionCode: 'US',
    _shoppingMode: 'SITE',
    _customerState: 'GUEST',
    ...urlParams,
  })}`;

  try {
    const response = await $http.get(url);
    if (response.data.product[0]) {
      return response.data.product[0];
    }
    return {};
  } catch (e) {
    return null;
  }
};

export const addToWishList = (upcId, onSucces, onError) => {
  if (upcId) {
    const path = '/xapi/wishlist/v1/';
    const userGuid = getUserGuid();
    const url = isBcom ? `${path}lists/items` : `${path}favorites`;
    const payload = {
      CustomerList: {
        user: { guid: userGuid },
        list: [{
          items: [{
            qtyRequested: 1,
            upc: { id: +upcId },
          }],
        }],
      },
    };

    const headerDict = {
      dataType: 'json',
    };

    try {
      $http.post(url, payload, headerDict)
        .then((response) => {
          onSucces(response);
        })
        .catch((error) => { onError(error); });
    } catch (error) {
      onError();
    }
  }
};
